// City coverage config. Each entry defines a city that can be visualized on the
// admin coverage map. Adding a new city = adding an entry; no code changes elsewhere.
//
// `geojsonUrl` must return a FeatureCollection of ZIP / postal polygons; the property
// holding the ZIP code is auto-detected by tryZipProperties() in PhlebCoverageMap.
//
// Env override (per city): set REACT_APP_<UPPER>_ZIP_GEOJSON_URL to override the URL
// at deploy time without code changes (e.g. REACT_APP_NYC_ZIP_GEOJSON_URL).

const CITIES = [
  {
    id: 'nyc',
    name: 'New York City',
    geojsonUrl:
      process.env.REACT_APP_NYC_ZIP_GEOJSON_URL ||
      'https://data.cityofnewyork.us/api/geospatial/pri4-ifjk?method=export&format=GeoJSON',
    center: { lat: 40.7128, lng: -74.006 },
    zoom: 10,
    // Used as a coarse fallback if the GeoJSON request fails — keeps the dashboard usable
    // and lets us count coverage on string-only data even with no polygons rendered.
    fallbackZips: [
      // Manhattan
      '10001','10002','10003','10004','10005','10006','10007','10009','10010','10011','10012','10013','10014','10016','10017','10018','10019','10021','10022','10023','10024','10025','10026','10027','10028','10029','10030','10031','10032','10033','10034','10035','10036','10037','10038','10039','10040','10044','10065','10069','10075','10128','10280','10282',
      // Brooklyn
      '11201','11203','11204','11205','11206','11207','11208','11209','11210','11211','11212','11213','11214','11215','11216','11217','11218','11219','11220','11221','11222','11223','11224','11225','11226','11228','11229','11230','11231','11232','11233','11234','11235','11236','11237','11238','11239','11249',
      // Queens
      '11101','11102','11103','11104','11105','11106','11354','11355','11356','11357','11358','11360','11361','11362','11363','11364','11365','11366','11367','11368','11369','11370','11371','11372','11373','11374','11375','11377','11378','11379','11385','11411','11412','11413','11414','11415','11416','11417','11418','11419','11420','11421','11422','11423','11426','11427','11428','11429','11430','11432','11433','11434','11435','11436','11691','11692','11693','11694','11697',
      // Bronx
      '10451','10452','10453','10454','10455','10456','10457','10458','10459','10460','10461','10462','10463','10464','10465','10466','10467','10468','10469','10470','10471','10472','10473','10474','10475',
      // Staten Island
      '10301','10302','10303','10304','10305','10306','10307','10308','10309','10310','10311','10312','10314',
    ],
  },
  // Add more cities here later. Example:
  // {
  //   id: 'chicago',
  //   name: 'Chicago',
  //   geojsonUrl: process.env.REACT_APP_CHICAGO_ZIP_GEOJSON_URL || 'https://...',
  //   center: { lat: 41.8781, lng: -87.6298 },
  //   zoom: 10,
  //   fallbackZips: [...],
  // },
];

export function getCities() {
  return CITIES;
}

export function getCity(id) {
  return CITIES.find((c) => c.id === id) || CITIES[0];
}

export function getDefaultCityId() {
  return process.env.REACT_APP_DEFAULT_COVERAGE_CITY || CITIES[0].id;
}
